import React, { useMemo } from 'react';
import CornerMark from './CornerMark';
import ResumeHeader from './ResumeHeader';
import SummarySection from './SummarySection';
import ExperienceSection from './ExperienceSection';
import EducationSection from './EducationSection';
import CertificationsSection from './CertificationsSection';
import ProjectsSection from './ProjectsSection';
import AwardsSection from './AwardsSection';

const TemplatePreview = React.forwardRef(function TemplatePreview({ template, data, accent, accent2 }, ref) {
  const effTemplate = useMemo(() => ({ ...template, accent2: accent2 || template.accent2 }), [template, accent2]);

  return (
    <div
      ref={ref}
      className="resume-page"
      style={{
        width: '8.5in',
        minHeight: '11in',
        background: '#FDFCF9',
        position: 'relative',
        padding: '0.75in',
        boxSizing: 'border-box',
        fontFamily: template.bodyFont,
        color: '#1c1c1c',
        fontSize: '10.5pt',
        lineHeight: 1.5,
        boxShadow: '0 1px 0 rgba(0,0,0,0.04), 0 12px 30px -10px rgba(20,20,40,0.12)',
      }}
    >
      <CornerMark template={effTemplate} accent={accent} />
      <ResumeHeader data={data} template={effTemplate} accent={accent} />
      {template.licensesProminent && data.certifications?.length > 0 && (
        <CertificationsSection data={data} template={effTemplate} accent={accent} />
      )}
      <SummarySection data={data} template={effTemplate} accent={accent} />
      <ExperienceSection data={data} template={effTemplate} accent={accent} />
      <EducationSection data={data} template={effTemplate} accent={accent} />
      {!template.licensesProminent && (
        <CertificationsSection data={data} template={effTemplate} accent={accent} />
      )}
      <ProjectsSection data={data} template={effTemplate} accent={accent} />
      <AwardsSection data={data} template={effTemplate} accent={accent} />
    </div>
  );
});

export default TemplatePreview;
